import React from 'react';

import {AutocompleteOptions, AutocompleteProps} from '../_types';

import {AutocompleteItem, AutocompleteItemBody} from './AutocompleteItem';

const AutocompleteOptionBase = <TOptions extends AutocompleteOptions>({
  option,
  renderOptionLabel: renderOptionLabelProp,
}: {
  option: Parameters<
    NonNullable<AutocompleteProps<TOptions>['renderOptionLabel']>
  >[0];
  renderOptionLabel?: AutocompleteProps<TOptions>['renderOptionLabel'];
}) => {
  const {description, label, isDisabled, isMultiline, prefix, value} = option;

  return (
    <AutocompleteItem
      isDisabled={isDisabled || option.disabled}
      key={value}
      prefix={prefix}
    >
      <AutocompleteItemBody description={description} isMultiline={isMultiline}>
        {renderOptionLabelProp
          ? renderOptionLabelProp(option, {context: 'menu'})
          : label}
      </AutocompleteItemBody>
    </AutocompleteItem>
  );
};

/**
 * We have to typecast our memo, since React.memo doesn't support generics.
 */
export const AutocompleteOption = React.memo(
  AutocompleteOptionBase
) as typeof AutocompleteOptionBase;
